import { render, staticRenderFns } from "./DecidedOpportunities.vue?vue&type=template&id=08c028d4&scoped=true&"
import script from "./DecidedOpportunities.vue?vue&type=script&lang=js&"
export * from "./DecidedOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./DecidedOpportunities.vue?vue&type=style&index=0&id=08c028d4&prod&lang=css&"
import style1 from "./DecidedOpportunities.vue?vue&type=style&index=1&id=08c028d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c028d4",
  null
  
)

export default component.exports